import { render, staticRenderFns } from "./ChartjsBarChart3.vue?vue&type=template&id=e925a42e&scoped=true&"
import script from "./ChartjsBarChart3.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChart3.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsBarChart3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChartjsBarChart3.vue?vue&type=style&index=1&id=e925a42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e925a42e",
  null
  
)

export default component.exports